// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"87":"c074094d","108":"a6c592ca","787":"bab1fa10","872":"49da8940"}[chunkId] + ".chunk.js";
};